export default "__VITE_ASSET__c72b75fa__"